import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemText,
  Button,
  Divider,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const TermsPage: React.FC = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    // 履歴があるかチェックして、なければチャットページに戻る
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/chat');
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        py: { xs: 2, sm: 4, md: 6 },
      }}
    >
      <Container maxWidth="md">
        {/* Header */}
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={handleBack}
            sx={{
              color: 'white',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              },
            }}
          >
            戻る
          </Button>
        </Box>

        <Paper
          elevation={8}
          sx={{
            p: { xs: 3, sm: 4, md: 6 },
            borderRadius: 3,
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(20px)',
          }}
        >
          {/* Title */}
          <Typography
            variant="h4"
            component="h1"
            gutterBottom
            sx={{
              fontWeight: 'bold',
              textAlign: 'center',
              mb: 4,
              background: 'linear-gradient(45deg, #667eea, #764ba2)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              color: 'transparent',
            }}
          >
            利用規約
          </Typography>

          {/* Company Information */}
          <Box sx={{ mb: 4, textAlign: 'center' }}>
            <Typography variant="h6" sx={{ mb: 1 }}>
              会社名：株式会社Gerbera
            </Typography>
            <Typography variant="body1" color="text.secondary">
              代表取締役：𠮷岡 歩真
            </Typography>
          </Box>

          <Divider sx={{ mb: 4 }} />

          {/* Introduction */}
          <Typography variant="body1" sx={{ mb: 4, lineHeight: 1.8 }}>
            この利用規約（以下「本規約」）は、株式会社Gerbera（以下「当社」）が提供するサービス「ガクフドキャリア」（以下「本サービス」）の利用条件を定めるものです。本サービスをご利用いただく前に、必ずお読みください。
          </Typography>

          {/* Terms Items */}
          <List sx={{ mb: 4 }}>
            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第1条（適用）
                  </Typography>
                }
                secondary={
                  <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                    本規約は、ユーザーと当社との間の本サービスの利用に関わる一切の関係に適用されるものとします。当社は本サービスに関し、本規約のほか、ご利用にあたってのルール等、各種の定め（以下「個別規定」）をすることがあります。これら個別規定はその名称のいかんに関わらず、本規約の一部を構成するものとします。
                  </Typography>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第2条（利用登録）
                  </Typography>
                }
                secondary={
                  <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                    本サービスにおいては、登録希望者が本規約に同意の上、当社の定める方法によって利用登録を申請し、当社がこれを承認することによって、利用登録が完了するものとします。当社は、利用登録の申請者に以下の事由があると判断した場合、利用登録の申請を承認しないことがあり、その理由については一切の開示義務を負わないものとします。
                  </Typography>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第3条（ユーザーIDおよびパスワードの管理）
                  </Typography>
                }
                secondary={
                  <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                    ユーザーは、自己の責任において、本サービスのユーザーIDおよびパスワードを適切に管理するものとします。ユーザーは、いかなる場合にも、ユーザーIDおよびパスワードを第三者に譲渡または貸与し、もしくは第三者と共用することはできません。当社は、ユーザーIDとパスワードの組み合わせが登録情報と一致してログインされた場合には、そのユーザーIDを登録しているユーザー自身による利用とみなします。
                  </Typography>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第4条（利用料金および支払方法）
                  </Typography>
                }
                secondary={
                  <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                    ユーザーは、本サービスの有料部分の対価として、当社が別途定め、本ウェブサイトに表示する利用料金を、当社が指定する方法により支払うものとします。ユーザーが利用料金の支払を遅滞した場合には、ユーザーは年14.6％の割合による遅延損害金を支払うものとします。
                  </Typography>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第5条（禁止事項）
                  </Typography>
                }
                secondary={
                  <Box sx={{ mt: 1 }}>
                    <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7 }}>
                      ユーザーは、本サービスの利用にあたり、以下の行為をしてはなりません。
                    </Typography>
                    <List dense sx={{ pl: 2 }}>
                      <ListItem sx={{ py: 0.5 }}>
                        <Typography variant="body2">
                          • 法令または公序良俗に違反する行為
                        </Typography>
                      </ListItem>
                      <ListItem sx={{ py: 0.5 }}>
                        <Typography variant="body2">
                          • 犯罪行為に関連する行為
                        </Typography>
                      </ListItem>
                      <ListItem sx={{ py: 0.5 }}>
                        <Typography variant="body2">
                          • 当社、本サービスの他のユーザー、または第三者のサーバーまたはネットワークの機能を破壊したり、妨害したりする行為
                        </Typography>
                      </ListItem>
                      <ListItem sx={{ py: 0.5 }}>
                        <Typography variant="body2">
                          • 当社のサービスの運営を妨害するおそれのある行為
                        </Typography>
                      </ListItem>
                      <ListItem sx={{ py: 0.5 }}>
                        <Typography variant="body2">
                          • 他のユーザーに関する個人情報等を収集または蓄積する行為
                        </Typography>
                      </ListItem>
                      <ListItem sx={{ py: 0.5 }}>
                        <Typography variant="body2">
                          • 不正アクセスをし、またはこれを試みる行為
                        </Typography>
                      </ListItem>
                      <ListItem sx={{ py: 0.5 }}>
                        <Typography variant="body2">
                          • 他のユーザーに成りすます行為
                        </Typography>
                      </ListItem>
                      <ListItem sx={{ py: 0.5 }}>
                        <Typography variant="body2">
                          • 当社のサービスに関連して、反社会的勢力に対して直接または間接に利益を供与する行為
                        </Typography>
                      </ListItem>
                      <ListItem sx={{ py: 0.5 }}>
                        <Typography variant="body2">
                          • その他、当社が不適切と判断する行為
                        </Typography>
                      </ListItem>
                    </List>
                  </Box>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第6条（本サービスの提供の停止等）
                  </Typography>
                }
                secondary={
                  <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                    当社は、以下のいずれかの事由があると判断した場合、ユーザーに事前に通知することなく本サービスの全部または一部の提供を停止または中断することができるものとします。なお、当社は、本条に基づき当社が行った措置に基づきユーザーまたは第三者に生じた損害について一切の責任を負わないものとします。
                  </Typography>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第7条（著作権）
                  </Typography>
                }
                secondary={
                  <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                    ユーザーは、自ら著作権等の必要な知的財産権を有するか、または必要な権利者の許諾を得た文章、画像や映像等の情報に関してのみ、本サービスを利用し、投稿ないしアップロードすることができるものとします。
                  </Typography>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第8条（利用制限および登録抹消）
                  </Typography>
                }
                secondary={
                  <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                    当社は、ユーザーが以下のいずれかに該当する場合には、事前の通知なく、投稿データを削除し、ユーザーに対して本サービスの全部もしくは一部の利用を制限しまたはユーザーとしての登録を抹消することができるものとします。
                  </Typography>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第9条（保証の否認および免責事項）
                  </Typography>
                }
                secondary={
                  <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                    当社は、本サービスに事実上または法律上の瑕疵（安全性、信頼性、正確性、完全性、有効性、特定の目的への適合性、セキュリティなどに関する欠陥、エラーやバグ、権利侵害などを含みます。）がないことを明示的にも黙示的にも保証しておりません。
                  </Typography>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第10条（サービス内容の変更等）
                  </Typography>
                }
                secondary={
                  <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                    当社は、ユーザーに通知することなく、本サービスの内容を変更しまたは本サービスの提供を中止することができるものとし、これによってユーザーに生じた損害について一切の責任を負いません。
                  </Typography>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第11条（利用規約の変更）
                  </Typography>
                }
                secondary={
                  <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                    当社は、必要と判断した場合には、ユーザーに通知することなくいつでも本規約を変更することができるものとします。なお、本規約の変更後、本サービスの利用を開始した場合には、当該ユーザーは変更後の規約に同意したものとみなします。
                  </Typography>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第12条（個人情報の取扱い）
                  </Typography>
                }
                secondary={
                  <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                    当社は、本サービスの利用によって取得する個人情報については、当社のプライバシーポリシーに従い適切に取り扱うものとします。
                  </Typography>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第13条（通知または連絡）
                  </Typography>
                }
                secondary={
                  <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                    ユーザーと当社との間の通知または連絡は、当社の定める方法によって行うものとします。当社は、ユーザーから、当社が別途定める方式に従った変更届け出がない限り、現在登録されている連絡先が有効なものとみなして当該連絡先へ通知または連絡を行い、これらは、発信時にユーザーへ到達したものとみなします。
                  </Typography>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第14条（権利義務の譲渡の禁止）
                  </Typography>
                }
                secondary={
                  <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                    ユーザーは、当社の書面による事前の承諾なく、利用契約上の地位または本規約に基づく権利もしくは義務を第三者に譲渡し、または担保に供することはできません。
                  </Typography>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第15条（準拠法・裁判管轄）
                  </Typography>
                }
                secondary={
                  <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                    本規約の解釈にあたっては、日本法を準拠法とします。本サービスに関して紛争が生じた場合には、当社の本店所在地を管轄する裁判所を専属的合意管轄とします。
                  </Typography>
                }
              />
            </ListItem>
          </List>

          <Divider sx={{ mb: 4 }} />

          {/* Contact Information */}
          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" component="div" sx={{ mb: 2, fontWeight: 'bold' }}>
              お問い合わせ先
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              電話番号：06-7176-5480
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              FAX番号：06-7635-8254
            </Typography>
            <Typography variant="body1">
              E-mail：info@gakufudo-career.jp
            </Typography>
          </Box>

          <Divider sx={{ mb: 3 }} />

          {/* Footer */}
          <Box sx={{ textAlign: 'right' }}>
            <Typography variant="body2" color="text.secondary">
              以上
            </Typography>
          </Box>
        </Paper>

        {/* Bottom Footer */}
        <Box sx={{ textAlign: 'center', mt: 4 }}>
          <Typography 
            variant="body2" 
            color="white" 
            sx={{ opacity: 0.8 }}
          >
            © {new Date().getFullYear()} 株式会社Gerbera. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default TermsPage; 